var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.278 21.375h7.356c.69 0 1.25-.56 1.25-1.25V8.768a1.25 1.25 0 00-.366-.884l-4.893-4.893a1.25 1.25 0 00-.883-.366H5.884c-.68 0-1.25.57-1.25 1.25v4.277",
    stroke: "#1B5AF6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.884 8.875h-5a1.25 1.25 0 01-1.25-1.25v-5M6.944 16.964a3.394 3.394 0 003.134-4.69 3.393 3.393 0 10-3.134 4.69z",
    stroke: "#1B5AF6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.364 15.773v5.6l2.583-1.651 2.582 1.651v-5.6",
    stroke: "#1B5AF6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSuccess;